import { editorLocalization } from "../editorLocalization";

var spanishTranslation = {
  // strings for survey templates
  survey: {
    edit: "Editar",
    dropQuestion:
      "Por favor coloque una pregunta aquí de la caja de herramientas en la izquierda.",
    copy: "Copiar",
    addToToolbox: "Añadir a la caja de herramientas",
    deletePanel: "Eliminar Panel",
    deleteQuestion: "Borrar Pregunta",
    convertTo: "Convertir a",
    drag: "Arrastrar Elemento"
  },
  //questionTypes
  qt: {
    default: "Predefinido",
    checkbox: "Checkbox",
    comment: "Comentario",
    dropdown: "Dropdown",
    file: "Archivo",
    html: "Html",
    matrix: "Matriz (elección única)",
    matrixdropdown: "Matriz (elección múltiple)",
    matrixdynamic: "Matriz (filas dinámicas)",
    multipletext: "Texto múltiple",
    panel: "Panel",
    paneldynamic: "Panel (paneles dinámicos)",
    radiogroup: "Grupo de radio",
    rating: "Rating",
    text: "Entrada sencilla",
    boolean: "Booleano",
    expression: "Expresión"
  },
  //Strings in Editor
  ed: {
    survey: "Encuesta",
    settings: "Ajustar Encuesta",
    editSurvey: "Editar Encuesta",
    addNewPage: "Añadir Nueva Página",
    moveRight: "Moverse hacia la derecha",
    moveLeft: "Moverse hacia la izquierda",
    deletePage: "Borrar Página",
    editPage: "Editar Página",
    edit: "Editar",
    newPageName: "página",
    newQuestionName: "pregunta",
    newPanelName: "panel",
    testSurvey: "Probar Encuesta",
    testSurveyAgain: "Probar Encuesta Otra Vez",
    testSurveyWidth: "Ancho de Encuesta: ",
    embedSurvey: "Empotrar Encuesta",
    saveSurvey: "Guardar Encuesta",
    designer: "Diseñador de Encuesta",
    jsonEditor: "Editor de JSON",
    undo: "Deshacer",
    redo: "Rehacer",
    options: "Opciones",
    generateValidJSON: "Generar JSON válido",
    generateReadableJSON: "Generar JSON legible",
    toolbox: "Caja de herramientas",
    toolboxGeneralCategory: "Categoría General",
    delSelObject: "Borrar objeto seleccionado",
    editSelObject: "Editar objeto seleccionado",
    correctJSON: "Por favor corrija JSON.",
    surveyResults: "Resultado de Encuesta: ",
    modified: "Modificado",
    saving: "Salvando",
    saved: "Salvado"
  },
  //Property names in table headers
  pel: {
    isRequired: "Requerido?"
  },
  //Property Editors
  pe: {
    apply: "Aplicar",
    ok: "OK",
    cancel: "Cancelar",
    reset: "Restaurar",
    close: "Cerrar",
    delete: "Borrar",
    addNew: "Añadir nuevo",
    addItem: "Click para añadir articulo...",
    removeAll: "Quitar todos",
    edit: "Editar",
    itemValueEdit: "Visible Si",
    editChoices: "Editar Opciones",
    move: "Mover",
    empty: "<vacío>",
    notEmpty: "<editar valor>",
    fastEntry: "Entrada rápida",
    formEntry: "Entrar en forma",
    testService: "Pruebe el servicio",
    conditionSelectQuestion: "Seleccionar pregunta...",
    conditionValueQuestionTitle: "Porfavor selecciona el valor",
    conditionButtonAdd: "Añadir",
    conditionButtonReplace: "Reemplazar",
    conditionHelp:
      "Por favor proporcione una expresión booleana. Debería regresar verdadero para mantener la pregunta/página visible. Por ejemplo: {pregunta1} = 'valor1' or ({pregunta2} * {pregunta4}  > 20 and {pregunta3} < 5)",
    expressionHelp:
      "Por favor proporcione una expresión. Puede hacer uso de llaves para tener acceso a los valores de la pregunta: '{pregunta1} + {pregunta2}', '({precio}*{cantidad}) * (100 - {descuento})'",
    aceEditorHelp:
      "Presione ctrl+espacio para obtener un indicio de completado de expresión",
    aceEditorRowTitle: "Fila actual",
    aceEditorPanelTitle: "Panel actual",
    showMore: "Por favor use la documentación para más detalles",
    conditionShowMoreUrl:
      "https://surveyjs.io/Documentation/LibraryParameter?id=Question&parameter=visibleIf",
    assistantTitle: "Preguntas disponibles:",
    cellsEmptyRowsColumns: "Debe haber al menos una columna o fila",
    propertyIsEmpty: "Por favor proporcione un valor",
    value: "Valor",
    text: "Texto",
    columnEdit: "Editar columna: {0}",
    itemEdit: "Editar artículo: {0}",
    url: "URL",
    path: "trayecto",
    valueName: "Nombre del valor",
    titleName: "Título",
    hasOther: "Tiene otro artículo",
    otherText: "Texto de otro artículo",
    name: "Nombre",
    title: "Título",
    cellType: "Tipo de celda",
    colCount: "Conteo de columnas",
    choicesOrder: "Orden de selección de elecciones",
    visible: "Es visible?",
    isRequired: "Es requerido?",
    startWithNewLine: "Es inicio con nueva línea?",
    rows: "Conteo de filas",
    placeHolder: "Marcador de entrada",
    showPreview: "Se muestra avance de imagen?",
    storeDataAsText:
      "Guardar contenido de archivo en resultado JSON como texto",
    maxSize: "Tamaño máximo de archivo en bytes",
    imageHeight: "Altura de imagen",
    imageWidth: "Ancho de imagen",
    rowCount: "Conteo de filas",
    columnsLocation: "Columns location",
    addRowLocation: "Agregar ubicación de botón de fila",
    addRowText: "Añadir texto de boton de fila",
    removeRowText: "Quitar texto de boton de fila",
    minRateDescription: "Descripción de la tasa mínima",
    maxRateDescription: "Descripción de la tarifa máxima",
    inputType: "Tipo de entrada",
    optionsCaption: "Leyenda de opciones",
    defaultValue: "Valor de defecto",
    cellsDefaultRow: "Textos de celdas por defecto",

    surveyEditorTitle: "Editar ajustes de encuesta",
    qEditorTitle: "Editar: {0}",

    //survey
    showTitle: "Mostrar/esconder título",
    locale: "Lenguaje de defecto",
    mode: "Modo (editar/solo lectura)",
    clearInvisibleValues: "Borrar valores invisibles",
    cookieName:
      "Nombre de Cookie (para deshabilitar corra encuesta dos veces localmente)",
    sendResultOnPageNext: "Mandar resultados de encuesta en página siguiente",
    storeOthersAsComment: "Guardar valor 'otros' en campo separado",
    showPageTitles: "Mostrar títulos de página",
    showPageNumbers: "Mostrar números de página",
    pagePrevText: "Texto de botón de página previa",
    pageNextText: "Texto de botón de página próxima",
    completeText: "Texto de botón de completado",
    startSurveyText: "Texto de botón de inicio",
    showNavigationButtons:
      "Mostrar botones de navigación (navegación de defecto)",
    showPrevButton:
      "Mostrar botón previo (el usuario puede regresar en página previa)",
    firstPageIsStarted:
      "La primera página en la encuesta es una página iniciada.",
    showCompletedPage: "Mostrar la página completada al final (completedHtml)",
    goNextPageAutomatic:
      "Al contestar todas las preguntas, ir a la próxima página automáticamente",
    showProgressBar: "Mostrar barra de progreso",
    questionTitleLocation: "Localización de título de pregunta",
    requiredText: "La pregunta requiere de símbolo(s)",
    questionStartIndex: "Índice de inicio de pregunta (1, 2 o 'A', 'a')",
    showQuestionNumbers: "Mostrar números de preguntas",
    questionTitleTemplate:
      "Plantilla de título de pregunta, defecto es: '{no}. {require} {title}'",
    questionErrorLocation: "Error en ubucación de la pregunta",
    focusFirstQuestionAutomatic:
      "Foco en primera pregunta al cambiar la página",
    questionsOrder: "Órden de elementos en la página",
    maxTimeToFinish: "Tiempo máximo para finalizar la encuesta",
    maxTimeToFinishPage:
      "Tiempo máximo para finalizar una página en la encuesta",
    showTimerPanel: "Mostrar panel de temporizador",
    showTimerPanelMode: "Modo de muestra de panel de temporizador",
    renderMode: "Modo de interpretador",
    allowAddPanel: "Permitir adición de un panel",
    allowRemovePanel: "Permitir remoción del panel",
    panelAddText: "Añadiendo texto de panel",
    panelRemoveText: "Quitando texto de panel",
    isSinglePage: "Mostrar todos los elementos en una página",

    tabs: {
      general: "General",
      fileOptions: "Opciones",
      html: "Editor Html",
      columns: "Columnas",
      rows: "Filas",
      choices: "Opciones",
      items: "Elementos",
      visibleIf: "Visible Si",
      enableIf: "Habilitar Si",
      rateValues: "Valores de tasa",
      choicesByUrl: "Opciones de la Web",
      matrixChoices: "Opciones de defecto",
      multipleTextItems: "Entradas de texto",
      validators: "Validadores",
      navigation: "Navegación",
      question: "Pregunta",
      completedHtml: "Html Completado",
      loadingHtml: "Cargando Html",
      timer: "Temporizador/Quiz",
      triggers: "Disparadores",
      templateTitle: "Título de plantilla"
    },
    editProperty: "Editar propiedad '{0}'",
    items: "[ Items: {0} ]",

    enterNewValue: "Por favor, proporcione el valor.",
    noquestions: "No hay ni una pregunta en la encuesta.",
    createtrigger: "Por favor cree un disparador",
    triggerOn: "En ",
    triggerMakePagesVisible: "Hacer páginas visibles:",
    triggerMakeQuestionsVisible: "Hacer elementos visibles:",
    triggerCompleteText: "Complete la encuesta en caso de éxito.",
    triggerNotSet: "El disparador no está configurado",
    triggerRunIf: "Correr si",
    triggerSetToName: "Cambiar valor de: ",
    triggerSetValue: "a: ",
    triggerIsVariable: "No poner la variable en el resultado de la encuesta."
  },
  //Property values
  pv: {
    true: "verdadero",
    false: "falso",
    inherit: "heredar",
    show: "mostrar",
    hide: "ocultar",
    default: "predefinido",
    initial: "inicial",
    random: "aleatorio",
    collapsed: "colapsado",
    expanded: "expandido",
    none: "ninguna",
    asc: "ascendente",
    desc: "descendente",
    indeterminate: "indeterminado",
    decimal: "decimal",
    currency: "moneda",
    percent: "por ciento",
    firstExpanded: "primeroExpandido",
    off: "apagado",
    onPanel: "onPanel",
    onSurvey: "onSurvey",
    list: "lista",
    progressTop: "progresoArriba",
    progressBottom: "progresoAbajo",
    progressTopBottom: "progresoArribaAbajo",
    horizontal: "horizontal",
    vertical: "vertical",
    top: "arriba",
    bottom: "abajo",
    topBottom: "arriba y abajo",
    left: "izquierda",
    color: "color",
    date: "fecha",
    datetime: "fecha y hora",
    "datetime-local": "fechaHora-local",
    email: "correo electrónico",
    month: "mes",
    number: "número",
    password: "contraseña",
    range: "rango",
    tel: "teléfono",
    text: "texto",
    time: "tiempo",
    url: "url",
    week: "semana",
    hidden: "oculto",
    on: "encendido",
    onPage: "onPage",
    edit: "editar",
    display: "mostrar",
    onComplete: "Cuando se complete",
    onHidden: "Cuando se oculte",
    all: "todo",
    page: "página",
    survey: "encuesta",
    onNextPage: "Cuando se cambie de página",
    onValueChanged: "Cuando el valor cambie"
  },
  //Operators
  op: {
    empty: "es vacío",
    notempty: "no es vacío",
    equal: "igual a",
    notequal: "no igual a",
    contains: "contiene",
    notcontains: "no contiene",
    greater: "mayor",
    less: "menor",
    greaterorequal: "mayor o igual a",
    lessorequal: "menor or igual a"
  },
  //Embed window
  ew: {
    angular: "Use versión Angular",
    jquery: "Use versión jQuery",
    knockout: "Use versión Knockout",
    react: "Use versión React",
    vue: "Use versión Vue",
    bootstrap: "Para entorno bootstrap",
    standard: "No bootstrap",
    showOnPage: "Mostrar encuesta en una página",
    showInWindow: "Mostrar encuesta en una ventana",
    loadFromServer: "Cargar JSON de encuesta del servidor",
    titleScript: "Scripts y estilos",
    titleHtml: "HTML",
    titleJavaScript: "JavaScript"
  },
  //Test Survey
  ts: {
    selectPage: "Seleccione la página para probarla:"
  },
  validators: {
    answercountvalidator: "cuenta de respuestas",
    emailvalidator: "e-mail",
    expressionvalidator: "expresión",
    numericvalidator: "numerico",
    regexvalidator: "regex",
    textvalidator: "texto"
  },
  triggers: {
    completetrigger: "encuesta completa",
    setvaluetrigger: "valor ajustado",
    visibletrigger: "cambio de visibilidad"
  },
  //Properties
  p: {
    name: "nombre",
    title: {
      name: "título",
      title: "Dejarlo vacío, si es igual que 'Nombre'"
    },
    page_title: { name: "título", title: "Título de página" },

    navigationButtonsVisibility: "Visibilidad de botones de navegación",
    questionsOrder: "Orden de las preguntas",
    maxTimeToFinish: "Tiempo máximo para terminar",

    visible: "Visible",
    visibleIf: "Visible Si",
    questionTitleLocation: "preguntaTituloLocacion",
    description: "Descripción",
    state: "Estado",
    isRequired: "Es Requerido",
    indent: "Indentar",
    requiredErrorText: "Texto del error",
    startWithNewLine: "Comenzar con una nueva línea",
    innerIndent: "Identación interna",
    page: "Página",

    width: "Ancho",

    commentText: "Texto del Comentario",
    valueName: "Nombre del valor",
    enableIf: "Habilitado Si",
    defaultValue: "Valor por defecto",
    correctAnswer: "Respuesta correcta",
    readOnly: "Solo Lectura",
    validators: "Validadores",
    titleLocation: "Titulo de la ubicación",

    hasComment: "Tiene Comentario",
    hasOther: "Tiene Otro",
    choices: "Elecciones",
    choicesOrder: "Orden de las opciones",
    choicesByUrl: "Opciones por URL",
    otherText: "Otro Texto",
    otherErrorText: "Texto del error para otro",
    storeOthersAsComment: "Guardar otros como comentario",

    label: "Etiqueta",
    showTitle: "Mostrar Título",
    valueTrue: "Valor Verdadero",
    valueFalse: "Valor Falso",

    cols: "Columnas",
    rows: "Filas",
    placeHolder: "Marcador de entrada",

    optionsCaption: "Opciones de Título",

    expression: "Expresión",
    format: "Formato",
    displayStyle: "Estilo de visualización",
    currency: "Moneda",
    useGrouping: "Usar agrupación",

    showPreview: "Mostrar vista previa",
    allowMultiple: "Permitir múltiples",
    imageHeight: "Altura de la imagen",
    imageWidth: "Ancho de la imagen",
    storeDataAsText: "Almacenar datos como texto",
    maxSize: "Tamaño máximo",

    html: "html",

    columns: "columnas",
    cells: "celdas",
    isAllRowRequired: "Se requieren todas las filas",

    horizontalScroll: "Desplazamiento horizontal",
    cellType: "Tipo de celda",
    columnsLocation: "Columnas de Locación",
    columnColCount: "Conteo de columna",
    columnMinWidth: "Ancho mínimo de columna",

    rowCount: "Conteo de fila",
    minRowCount: "Conteo mínima de fila",
    maxRowCount: "Conteo máxima de fila",
    keyName: "Nombre clave",
    keyDuplicationError: "Mensaje de error para clave de duplicada",
    confirmDelete: "Confirmación de eliminación",
    confirmDeleteText: "Texto de la confirmación para eliminación",
    addRowLocation: "Agrega fila de ubicación",
    addRowText: "Agregar texto de la fila",
    removeRowText: "Quitar texto de la fila",

    items: "ítems",
    itemSize: "Tamaño del ítem",
    colCount: "Conteo de columnas",

    templateTitle: "Título de la plantilla",
    templateDescription: "Descripción de la platilla",
    allowAddPanel: "Permitir agregar panel",
    allowRemovePanel: "Permitir eliminar panel",
    panelCount: "Conteo de panel",
    minPanelCount: "Conteo mínimo de panel",
    maxPanelCount: "Conteo máximo de panel",
    panelsState: "Paneles de Estado",
    panelAddText: "Agregar texto al panel",
    panelRemoveText: "Eliminar texto al panel",
    panelPrevText: "Texto anterior del panel",
    panelNextText: "Texto siguiente del panel",
    showQuestionNumbers: "Nostrar números de pregunta",
    showRangeInProgress: "Mostrar el rango de progreso",
    renderMode: "Modo renderizado",
    templateTitleLocation: "Plantilla del Título Ubicación",

    rateValues: "Valores de tarifa",
    rateMin: "Tarifa mínima",
    rateMax: "Tarifa máxima",
    rateStep: "Pasos de tarifa",
    minRateDescription: "Descripción mínima de tarifa",
    maxRateDescription: "Descripción máxima de tarifa",

    inputType: "Tipo de entrada",
    size: "Tamaño",

    locale: "Lugar",
    focusFirstQuestionAutomatic: "Enfocar primera pregunta automática",
    completedHtml: "HTML Completado",
    completedBeforeHtml: "Completado antes de HTML",
    loadingHtml: "Cargando HTML",
    triggers: "Disparadores",
    cookieName: "Nombre de la cookie",
    sendResultOnPageNext: "Enviar resultado a la página siguiente",
    showNavigationButtons: "Mostrar botones de navegación",
    showPrevButton: "Mostrar botón anterior",
    showPageTitles: "Mostrar Títulos de la página",
    showCompletedPage: "Mostrar página completada",
    showPageNumbers: "Mostrar los números de página",
    questionErrorLocation: "Pregunta error ubicación",
    showProgressBar: "Mostrar barra de progreso",
    mode: "Modo",
    goNextPageAutomatic: "Ir a la siguiente página automática",
    checkErrorsMode: "Verifica el modo de errores",
    clearInvisibleValues: "Limpiar en valores visibles",
    startSurveyText: "Comenzar el texto de la encuesta",
    pagePrevText: "Texto anterior de la página",
    pageNextText: "Texto siguiente de la página",
    completeText: "Texto completado de la página",
    requiredText: "Texto requerido",
    questionStartIndex: "Índice de inicio de pregunta",
    questionTitleTemplate: "Título platilla de la pregunta",
    firstPageIsStarted: "Se inicia la primera página",
    isSinglePage: "Es una sola página",
    maxTimeToFinishPage: "Tiempo máximo para terminar la página",
    showTimerPanel: "Mostrar tiempo del panel",
    showTimerPanelMode: "Mostrar tiempo del modo panel",

    text: "texto",
    minValue: "Valor mínimo",
    maxValue: "Valor máximo",
    minLength: "Largo mínimo",
    maxLength: "Largo máximo",
    allowDigits: "Permitir dígitos",
    minCount: "Conteo mínimo",
    maxCount: "Conteo máximo",
    regex: "Expresión regular"
  }
};

editorLocalization.locales["es"] = spanishTranslation;
